import type { SVGProps } from 'react'
import { forwardRef } from 'react'
import type { IconNodeName } from './icons'
import { useIconSize, useIconSpriteHref } from './use-icon-sprite-context'

type IconProps = {
	name?: IconNodeName
	size?: number
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>

export class IconError extends Error {
	constructor(message: string) {
		super(message)
		this.name = 'IconError'
	}
}

export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon(
	{ name = 'empty', size: overriddenSize, ...props },
	ref,
) {
	const href = useIconSpriteHref(name)
	const defaultSize = useIconSize()
	const size = overriddenSize ?? defaultSize
	return (
		<svg {...props} ref={ref} width={size} height={size}>
			<title>{name}</title>
			{href ? (
				<use href={href} />
			) : (
				<rect width={size} height={size} fill="none" stroke="none" />
			)}
		</svg>
	)
})
